import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { billingKeys } from "@/lib/query-keys";
import type { MySubscription } from "@/types/domain";

/** Suscripción vigente de la organización. `null` si el usuario aún no tiene plan. */
export function useMySubscription(enabled = true) {
  return useQuery({
    queryKey: billingKeys.subscription(),
    enabled,
    queryFn: () => fetchToBackend<MySubscription | null>("/subscriptions/me"),
  });
}
